import { MarkdownProps } from '@common/ts/types';
import ReactMarkdown from 'react-markdown';

function MarkdownParagraph({ children, ...props }: any) {
  return (
    <p className="mb-5 last:mb-0" {...props}>
      {children}
    </p>
  );
}

function MarkdownUl({ children, ...props }: any) {
  return (
    <ul className="list-disc pl-4 mb-5" {...props}>
      {children}
    </ul>
  );
}

function MarkdownOl({ children, ...props }: any) {
  return (
    <ol className="list-decimal pl-4 mb-5" {...props}>
      {children}
    </ol>
  );
}

function MarkdownH1({ children, ...props }: any) {
  return (
    <h1 className="text-sm font-bold mb-3 mt-5 first:mt-0" {...props}>
      {children}
    </h1>
  );
}

function MarkdownH2({ children, ...props }: any) {
  return (
    <h2 className="text-sm font-semibold mb-2 mt-4 first:mt-0" {...props}>
      {children}
    </h2>
  );
}

function MarkdownH3({ children, ...props }: any) {
  return (
    <h3 className="text-sm font-medium mb-2 mt-3 first:mt-0" {...props}>
      {children}
    </h3>
  );
}

function MarkdownStrong({ children, ...props }: any) {
  return (
    <strong className="font-bold" {...props}>
      {children}
    </strong>
  );
}

function Markdown({ isParagraphSpanEl, children, ...rest }: MarkdownProps) {
  if (!children) return null;

  // Remove ```markdown blocks that break styling
  const cleanedContent = children.replace(/```markdown\n?/g, '').replace(/\n?```$/g, '');
  return (
    <ReactMarkdown
      components={{
        p: isParagraphSpanEl ? 'span' : MarkdownParagraph,
        ul: MarkdownUl,
        ol: MarkdownOl,
        h1: MarkdownH1,
        h2: MarkdownH2,
        h3: MarkdownH3,
        strong: MarkdownStrong,
      }}
      {...rest}
    >
      {cleanedContent}
    </ReactMarkdown>
  );
}

export default Markdown;
